var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/mdedge_icon.png"),"alt":"mdedge icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }